import { all, call, put, takeLatest } from 'redux-saga/effects'
import axios from 'axios'
import {
    SMB_GET_ORDER_REQUEST,
    SMB_REORDER_REQUEST,
    SMB_SUBMIT_REFUND_REQUEST,
    smbGetOrderResponse,
    smbReorderResponse,
    smbSubmitRefundResponse,
} from '../actions/orderDetails'
import * as Sentry from '@sentry/react'
import { smbCopyCartSuccess } from '../actions/smbCart'

function* requestRefund(action) {
    const { orderNumber, reason, note, items } = action.payload

    try {
        const { data } = yield call(axios.request, {
            url: `/account/orders/${orderNumber}/request-refund/`,
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            data: {
                refund_reason: reason,
                note: note,
                items: items,
            },
        })
        yield put(smbSubmitRefundResponse(data.refund_number))
    } catch (e) {
        yield call(Sentry.captureException, e)
        yield put(smbSubmitRefundResponse(e.response, '', true))
    }
}

function* reorder(action) {
    const { orderNumber } = action.payload

    try {
        const { data } = yield call(axios.request, {
            url: `/ajax/copy-cart-from-order/${orderNumber}/`,
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
        yield put(smbReorderResponse())
        yield put(smbCopyCartSuccess(data))
    } catch (e) {
        yield call(Sentry.captureException, e)
        const errorMessage =
            e.response?.data?.message ??
            'Your request failed. Refresh the\n' +
                'page and try again or contact our\n' +
                'support team.'
        yield put(smbReorderResponse(errorMessage, '', true))
    }
}

function* getOrder(action) {
    const { orderNumber } = action.payload

    try {
        const { data } = yield call(axios.request, {
            url: `/account/orders/ajax/${orderNumber}/`,
            method: 'GET',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
        yield put(smbGetOrderResponse(data))
    } catch (e) {
        yield call(Sentry.captureException, e)
        const errorMessage =
            e.response?.data?.message ??
            'Your request failed. Refresh the\n' +
                'page and try again or contact our\n' +
                'support team.'
        yield put(smbGetOrderResponse(errorMessage, '', true))
    }
}

export function* orderDetailsSagas() {
    yield all([
        takeLatest(SMB_SUBMIT_REFUND_REQUEST, requestRefund),
        takeLatest(SMB_REORDER_REQUEST, reorder),
        takeLatest(SMB_GET_ORDER_REQUEST, getOrder),
    ])
}

export default orderDetailsSagas
